import React from 'react';
import Menu from './components/Menu';
import './App.css';

function App() {
  return (
    <div className="App">
      <Menu />
    </div>
  );
}

export default App;
